// ─── Polling & Refresh (ms) ───────────────────────────────────────────────────
export const POLLING = {
  GPS_INTERVAL_MS: 5000, // refresh carte GPS / suivi temps réel
  FLEET_INTERVAL_MS: 5000, // refresh fleet monitor
};

// ─── UI Timeouts (ms) ────────────────────────────────────────────────────────
export const UI = {
  MESSAGE_TIMEOUT_MS: 3000, // durée affichage messages succès / erreur
  AUDIENCE_LIST_PREVIEW: 10, // personnes listées dans le détail d'une annonce personnalisée, puis « et N autres »
};

// ─── WebSocket ────────────────────────────────────────────────────────────────
export const WEBSOCKET = {
  RECONNECT_INTERVAL_MS: 3000,
  MAX_RECONNECT_ATTEMPTS: 5,
  SOCKET_TIMEOUT_MS: 10000,
};

// ─── Pagination ───────────────────────────────────────────────────────────────
export const PAGINATION = {
  TRIPS_LIMIT: 50,
  STOPS_LIMIT: 5000,
  REQUESTS_LIMIT: 100, // borne haute backend (LIMITS.PAGINATION_MAX) — mitigation du plafond par défaut (50)
  LOOKUP_LIMIT: 100, // listes de sélection (circuits d'une annonce) : borne haute backend (LIMITS.PAGINATION_MAX)
  BROADCASTS_LIMIT: 20, // annonces par page (historique « Notifications envoyées »)
};

// ─── Carte historique trajet ──────────────────────────────────────────────────
// Seuils de vitesse pour la polyligne colorée (km/h)
export const TRIP_MAP = {
  SPEED_SLOW_KMH: 15, // ≤ 15 km/h → vert  (bus à l'arrêt ou ralentit)
  SPEED_MEDIUM_KMH: 40, // 16-40 km/h → orange (circulation normale)
  // > 40 km/h    → rouge  (vitesse élevée)
  COLOR_SLOW: '22c55e', // vert
  COLOR_MEDIUM: 'f97316', // orange
  COLOR_FAST: 'ef4444', // rouge
  COLOR_STOP: 'eab308', // jaune — marqueurs arrêts sur la carte
  MAP_STYLE: 'streets-v12',
  STROKE_WIDTH: 4,

  // Délais replay (ms/trame) — ~200 trames max après simplification backend
  REPLAY_DELAY_SLOW_MS: 320, // (0.5×)
  REPLAY_DELAY_NORMAL_MS: 160, // (1×)
  REPLAY_DELAY_FAST_MS: 80, // (2×)
};

// ─── Rétention données ────────────────────────────────────────────────────────
export const DATA_RETENTION = {
  GPS_BASIC_DAYS: 30, // miroir de TIMING.GPS_RETENTION_BASIC_DAYS backend
};

// ─── Historique des annonces admin (Notifications envoyées) ──────────────────
export const BROADCAST_PERIODS = {
  SHORT_DAYS: 7, // miroir de TIMING.TRIP_HISTORY_SHORT_WINDOW_DAYS backend
  DEFAULT_DAYS: 30, // miroir de TIMING.TRIP_HISTORY_DEFAULT_DAYS backend
  LONG_DAYS: 90,
};

// Limites de saisie alignées sur la validation backend (schémas Joi de src/api/admin/*.routes.js)
export const FORM_LIMITS = {
  STOP_ADDRESS_MIN_LENGTH: 5,
  BROADCAST_TITLE_MAX: 100, // miroir de LIMITS.BROADCAST_TITLE_MAX backend
  BROADCAST_TITLE_SOFT_LIMIT: 50, // au-delà, le titre risque d'être tronqué sur l'écran verrouillé
  BROADCAST_BODY_MAX: 1000, // miroir de LIMITS.BROADCAST_BODY_MAX backend
};
